import DataStore from '@/engine/stores/data-store';

class AdminTemplateDataStore extends DataStore {

}

export default new AdminTemplateDataStore();
